import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AppSubscriptionGuard } from "@app/app-subscription.guard";
import { extract } from "@app/core";
import { Shell } from "@app/shell/shell.service";
import { HomeComponent } from "./home.component";

const routes: Routes = [
	Shell.childRoutes(
		[
			{
				path: "",
				redirectTo: "/timer",
				pathMatch: "full",
			},
			{
				path: "timer",
				component: HomeComponent,
				data: { title: extract("timer.single") },
			},
		],
		{
			canActivate: [AppSubscriptionGuard],
			runGuardsAndResolvers: "always",
		}
	),
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
	providers: [],
})
export class HomeRoutingModule {}
